import { createBrowserRouter, redirect } from "react-router-dom";

import {
  ActiveChat,
  Feedback,
  HomePage as RootLayout,
  LoginPage,
  NewChat,
} from "../pages";
import Main from "../pages/Main";
import Dashboard from "../pages/Dashboard";
import RootError from "../pages/Errors/RootError";

const router = createBrowserRouter([
  { path: "/login", element: <LoginPage /> },
  {
    path: "/",
    element: <RootLayout />,
    id: "root",
    errorElement: <RootError />,
    loader: () => {
      const username = localStorage.getItem("username");
      localStorage.setItem("activeBrand", "CampusIN77061c54e1a2c807");
      if (username && username !== "") {
        return username;
      } else return redirect("/login");
    },
    children: [
      { path: "/", element: <Main /> },
      { path: "new-chat", element: <NewChat /> },
      {
        path: "/dashboard/:dashboardId",
        element: <Dashboard />,
      },
      { path: "/chat/:chatId", element: <Main /> },
      {
        path: "chat-id",
        element: <ActiveChat />,
        children: [{ path: "feedback", element: <Feedback /> }],
      },
      {
        path: "logout",
        action: () => {
          localStorage.setItem("username", "");
          return redirect("/login");
        },
      },
    ],
  },
]);

export default router;
